import { render, staticRenderFns } from "./ChangeItemDetails.vue?vue&type=template&id=2f0935be&scoped=true"
import script from "./ChangeItemDetails.vue?vue&type=script&lang=js"
export * from "./ChangeItemDetails.vue?vue&type=script&lang=js"
import style0 from "./ChangeItemDetails.vue?vue&type=style&index=0&id=2f0935be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f0935be",
  null
  
)

export default component.exports